export const SESSION_COOKIE_NAME = "layup_session";
export const SESSION_STATE_COOKIE_NAME = "layup_session_state";
export const SESSION_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;
